import React from 'react';

import {observer} from "mobx-react"
import {
  PreviousMeetingsWidgetScoreResult,
} from "./previous-meetings-widget.score-result";
import {PreviousMeetingsWidgetStatisticsViewModel} from "../models/previous-meetings-widget.statistics.view-model";
import {PreviousMeetingsWidgetTerms} from "../previous-meetings-widget.terms";
import {DeviceViewModel} from "../../../core/models/device.view-model";
import {BaseProps} from "../../../infrastructure/models/props/base-props";
import classNames from "classnames";
import styles from "../styles/previous-meetings-widget.module.scss";

export class PreviousMeetingsWidgetTotalScoresProps extends BaseProps {
  statistics: PreviousMeetingsWidgetStatisticsViewModel;
  device: DeviceViewModel;
  i18n: PreviousMeetingsWidgetTerms;
}


export const PreviousMeetingsWidgetTotalScores = observer(({controller}: PreviousMeetingsWidgetTotalScoresProps) => {
  const {state} = controller;
  const {statistics, terms, shouldRenderDraws} = state;

  const previousMeetingsWidgetScoreResultPropsHomeWins = {
    score: statistics.homeWins,
    type: terms.H2H_WINS,
  };

  const previousMeetingsWidgetScoreResultPropsDraws = {
    score: statistics.draws,
    type: terms.H2H_DRAWS,
  };

  const previousMeetingsWidgetScoreResultPropsAwayWins = {
    score: statistics.awayWins,
    type: terms.H2H_WINS,
  };


  return (
    <div className={classNames(styles.total_scores_container)}>
      <PreviousMeetingsWidgetScoreResult {...previousMeetingsWidgetScoreResultPropsHomeWins}/>
      {
        shouldRenderDraws && (
        <>
          <div className={classNames(styles.divider)}/>
          <PreviousMeetingsWidgetScoreResult
            {...previousMeetingsWidgetScoreResultPropsDraws}/>
        </>
      )
      }
      <div className={classNames(styles.divider)}/>
      <PreviousMeetingsWidgetScoreResult {...previousMeetingsWidgetScoreResultPropsAwayWins}/>
    </div>
  )
});
